<!--  -->
<template>
  <div>
    <el-table
      v-loading="listLoading"
      :data="tabledata"
      max-height="550"
      border
    >
      <el-table-column
        prop="group_number"
        width="310"
        label="组号"
        align="center"
      />
      <el-table-column
        prop="status_desc"
        width="100"
        label="状态"
        align="center"
      />
      <el-table-column
        prop="resp_msg"
        label="响应信息"
        align="center"
      />
      <el-table-column
        prop="is_master_desc"
        width="180"
        label="日志"
        align="center"
      />
      <el-table-column
        prop="fail_reason"
        label="失败原因"
        align="center"
      />
    </el-table>
    <pagination-right
      :current-page="query.page"
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
  </div>
</template>

<script>
import { select_adgroups_record } from '@/api/releaseGroup.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  components: { PaginationRight },

  data() {
    return {
      listLoading: false,
      query: {
        group_number: null,
        record_type: null,
        page: 1,
        pageSize: 10
      },
      tabledata: [],
      total: null,
      success_count: ''
    }
  },
  created() {},
  mounted() {},
  methods: {
    send(item) {
      this.query.group_number = item.group_number
      this.query.record_type = '2'
      this.list()
    },
    async list() {
      this.listLoading = true
      const data = await select_adgroups_record(this.query)
      this.tabledata = data.data.list
      this.total = data.data.count
      this.listLoading = false
      console.log('data', data)
    },
    // 分页
    fetchPageSize(e) {
      this.query.pageSize = e
      this.list()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.list()
    },
    searchclick() {
      this.query.page = 1
      this.list()
    },
    rechargeclick() {
      this.query = {
        group_number: null,
        record_type: null,
        page: 1,
        pageSize: 10
      }
      // this.query.sp_strategy_title = null
      this.list()
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.tabselecr_box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}
.titip {
  width: 180px;
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1; /* 这里是超出几行省略 */
  overflow: hidden;
}
.maewrr {
  font-size: 19px;
  color: #f56c6c;
}
</style>
